import Medal from '../src/Medal/index.tsx';
export default Medal;
